export const listaInvitados = {
  /* ==========================
     INVITADOS DE CELI
     ========================== */
  "mama-herlinda": {
    nombre: "Mamá Herlinda Velasco",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "celina",
    mensaje: "Mamá, gracias por todo tu amor y apoyo.",
    telefono: "+529514972623"
  },
  "papa-antonio": {
    nombre: "Papá Antonio Cruz",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "celina",
    mensaje: "Papá, tu presencia es indispensable en este día.",
    telefono: "+529514972623"
  },
  "familia-otoniel": {
    nombre: "Familia Liz y Otoniel",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    mensaje: "Liz, gracias por tu apoyo. Te quiero mucho.",
    telefono: "+529511233759"
  },
  "familia-hna-vero": {
    nombre: "Familia de la Hna. Vero",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "celina",
    telefono: ""
  },
  "yolanda-y-papa":{
    nombre: "Yolanda y Papá",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: "+524433423456"
  },
  "paola": {
    nombre: "Paola Cruz",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "celina",
    telefono: "+524433427256"
  },
  "tio-juan": {
    nombre: "Familia Tío Juan Velasco",
    pases: 4,
    adultos: 3,
    ninos: 1,
    host: "celina",
    telefono: ""
  },
  "familia-hno-pedro": {
    nombre: "Familia del Hno. Pedro Ángeles",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "celina",
    telefono: "+524431907673"
  },
  "familia-hno-julio": {
    nombre: "Familia del Hno. Julio Paxtián",
    pases: 3,
    adultos: 2,
    ninos: 1,
    host: "celina",
    telefono: "+524432170782"
  },
  "familia-hno-javier": {
    nombre: "Familia del Hno. Javier Caltenco",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "celina",
    telefono: "+524431700893"
  },
  "familia-hno-juan": {
    nombre: "Familia del Hno. Juan Caltenco",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: "+524431364284"
  },
  "familia-hna-alicia": {
    nombre: "Familia de la Hna. Alicia González",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "celina",
    telefono: "+524431866837"
  },
  "familia-hno-alfonso": {
    nombre: "Familia del Hno. Alfonso Caltenco",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: ""
  },
  "familia-cyndi": {
    nombre: "Familia de Cyndi Guzmán",
    pases: 3,
    adultos: 2,
    ninos: 1,
    host: "celina",
    telefono: ""
  },
  "lupita": {
    nombre: "Lupita Ramos",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "celina",
    telefono: "+524437349450"
  },
  "noelia": {
    nombre: "Noelia Blancas",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "celina",
    telefono: "+524431725052"
  },
  "luz": {
    nombre: "Luz Elena García",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "celina",
    telefono: "+523511626916"
  },
  "orlando": {
    nombre: "Orlando Morales & Cristel Azenet",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: "+524438453922"
  },
  "daysi": {
    nombre: "Daysi Hernández",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: "+529515943219"
  },
  "dalis": {
    nombre: "Dalia de la Rosa",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: "+524432070320"
  },
  "ana": {
    nombre: "Ana Maldonado y Esposo",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: ""
  },
  "hna-lilia": {
    nombre: "Hna. Lilia.",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "celina",
    telefono: ""
  },
  "esther-marcos": {
    nombre: "Esther Marcos",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "celina",
    telefono: ""
  },
  "kimberly-sanchez": {
    nombre: "Kimberly Sánchez",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "celina",
    telefono: ""
  },
  "arq-jose-maldonado": {
    nombre: "Arq. José Maldonado",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "celina",
    telefono: "+524433182517"
  },

  /* ==========================
     INVITADOS DE JAZIEL
     ========================== */
  "mama-adareli": {
    nombre: "Mamá Adareli Garrido",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    mensaje: "Gracias por ser el pilar de mi vida.",
    telefono: "+524623768885"
  },
  "papa-ignacio": {
    nombre: "Papá Ignacio Panduro",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    mensaje: "",
    telefono: "+523311195741"
  },
  "familia-tia-lety": {
    nombre: "Familia Tía Lety",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "jaziel",
    mensaje: "Gracias tía por tu amor y apoyo incondicional, siempre serás mi segunda mamá. Te amo.",
    telefono: "+523411254515"
  },
  "familia-tio-david": {
    nombre: "Familia Tío David",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "jaziel",
    mensaje: "Gracias tío por ser un ejemplo a seguir y por todo el apoyo que me has brindado. Los quiero mucho a ti, a mi tía Sori, a mis primos Yael y Yaretzi.",
    telefono: "+523323208695"
  },
  "hno-carlitos": {
    nombre: "Hno. Carlitos y Abuelita",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524291098621"
  },
  "hna-pili": {
    nombre: "Hna. Pili",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524621033066"
  },
  "hna-angy": {
    nombre: "Angy e hija",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524623768885"
  },
  "familia-hno-tanis": {
    nombre: "Hno. Tanis, Sarita, Aby y Eduardo Solís",
    pases: 4,
    adultos: 3,
    ninos: 1,
    host: "jaziel",
    mensaje: "Gracias por todo el apoyo que nos han brindado a Celina y a mí Hermano Tanis. Los queremos mucho.",
    telefono: "+524776477548"
  },
  "hno-ruben-y-esposa": {
    nombre: "Hno. Rubén S. y Hna. Dana",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    mensaje: "Amigo, gracias por tu apoyo y amistad, desde que estuve contigo ministrando has sido de mucha bendición, gracias a Dios por tu vida.",
    telefono: "+524623438309"
  },
  "hno-daniel-y-esposa": {
    nombre: "Hno. Daniel S. y Hna. Sara",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524622638331"
  },
  "hno-valle": {
    nombre: "Hno. Valle y Esposa",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524621331069"
  },
  "francisco-mary-ballon": {
    nombre: "Francisco & Mary Ballón",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524623418585"
  },
  "karen-ballon": {
    nombre: "Ana Karen Ballón",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524623418585"
  },
  "alejandra-ballon": {
    nombre: "Alejandra Ballón",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524623418585"
  },
  "jocelyn-ballon": {
    nombre: "Jocelyn Ballón",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524623418585"
  },
  "ricardo-ballon": {
    nombre: "Ricardo Ballón",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524623418585"
  },
  "hno-daniel-r-y-esposa": {
    nombre: "Hno. Daniel R y Esposa",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524621211982"
  },
  "familia-hno-gerardo": {
    nombre: "Familia del Hno. Gerardo Elizarraraz",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "jaziel",
    telefono: "+524622108999"
  },
  "familia-hna-sele": {
    nombre: "Familia de la Hna. Selene Elizarraraz",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "jaziel",
    telefono: "+524622085384"
  },
  "hno-gonzalo-y-esposa": {
    nombre: "Hno. Gonzalo González y esposa",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "jaziel",
    telefono: "+524451028705"
  },
  "hno-ernesto-quiroz": {
    nombre: "Hno. Ernesto Quiroz y Esposa",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "jaziel",
    telefono: "+524191188340"
  },
  "familia-mariel": {
    nombre: "Hno. Isaias & Hna. Claudia y Mariel",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "jaziel",
    mensaje: "Gracias por tu apoyo y amistad incondicional. ",
    telefono: "+524623342067"
  },
  "jenny-david": {
    nombre: "Jenny & David",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524296977743"
  },
  "miguel-novia": {
    nombre: "Miguel & Novia",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524622617952"
  },
  "david-o-y-reny": {
    nombre: "David Osorio & Reny",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    mensaje: "David, gracias por tu amistad y apoyo incondicional. Eres mi hermano y mi amigo, te aprecio mucho, espero en Dios que podamos seguir creciendo juntos y ahora con nuestras esposas.",
    telefono: "+524623386550"
  },
  "familia-cristian": {
    nombre: "Familia Cristian",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524621284528"
  },
  "familia-hna-angy": {
    nombre: "Hno. Martin & Hna. Angy, Samuel y Aby",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "jaziel",
    telefono: "+524731125188"
  },
  "familia-omar": {
    nombre: "Familia de Omar",
    pases: 4,
    adultos: 3,
    ninos: 1,
    host: "jaziel",
    telefono: "+524735605551"
  },
  "familia-sebastian": {
    nombre: "Sebastian y Eva e hijos.",
    pases: 4,
    adultos: 3,
    ninos: 1,
    host: "jaziel",
    telefono: "+524731476558"
  },
  "familia-jonny-jessica": {
    nombre: "Jonny y Jessica e hijos",
    pases: 4,
    adultos: 3,
    ninos: 1,
    host: "jaziel",
    telefono: "+524731046994"
  },
  "familia-jonny-gaby": {
    nombre: "Jonny y Gaby e hijos",
    pases: 4,
    adultos: 2,
    ninos: 2,
    host: "jaziel",
    telefono: "+524731237442"
  },
  "familia-fabian": {
    nombre: "Fabian y Pricila e hijos",
    pases: 3,
    adultos: 2,
    ninos: 1,
    host: "jaziel",
    telefono: "+524734590645"
  },
  "familia-lupita-gaytan": {
    nombre: "Hno. Salvador & Hna. Lupita Gaytan, Mayra y Emanuel",
    pases: 4,
    adultos: 4,
    ninos: 0,
    host: "jaziel",
    telefono: ""
  },
  "familia-liz-gaytan": {
    nombre: "Mario y Liz Gaytan e hija.",
    pases: 3,
    adultos: 2,
    ninos: 1,
    host: "jaziel",
    telefono: "+524731440750"
  },
  "familia-hno-jorge": {
    nombre: "Hno. Jorge & Hna. Elizabeth y Brenda",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "jaziel",
    telefono: "+524775913804"
  },
  "hna-andrea-e-hijo": {
    nombre: "Hna. Andrea y Hno. Juan Aguayo",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524731056230"
  },
  "hna-lupita": {
    nombre: "Hna. Lupita Aguayo",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524731142667"
  },
  "familia-hna-cristiana": {
    nombre: "Hna. Cristiana",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: "+524731714708"
  },
  "hna-estela": {
    nombre: "Hna. Estela",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524731395714"
  },
  "hno-eduardo-y-hna-lourdes": {
    nombre: "Hno. Eduardo & Hna. Lourdes",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "jaziel",
    telefono: ""
  },
  "hna-josefina": {
    nombre: "Hna. Josefina y Fabian",
    pases: 2,
    adultos: 1,
    ninos: 1,
    host: "jaziel",
    telefono: ""
  },
  "familia-garrido": {
    nombre: "Familia Garrido",
    pases: 10,
    adultos: 10,
    ninos: 0,
    host: "jaziel",
    telefono: ""
  },
  "familia-hno-alberto": {
    nombre: "Hno. Alberto & Hna. Flor e hijo.",
    pases: 3,
    adultos: 2,
    ninos: 1,
    host: "jaziel",
    telefono: "+524622878051"
  },
  "hno-gerson": {
    nombre: "Hno. Gerson",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "jaziel",
    telefono: "+524777923212"
  },
  "familia-rafa": {
    nombre: "Hno. Rafa y esposa e hija",
    pases: 4,
    adultos: 3,
    ninos: 1,
    host: "jaziel",
    telefono: "+524722450781"
  },
  "familia-hno-moy": {
    nombre: "Hno. Moy y Esposa e hijo",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "jaziel",
    telefono: "+524623327455"
  }
};